<mgt-login class="col-xs-12 sp-0"></mgt-login>

<button class="col-xs-12 sp-0 btn btn-default" (click)="test()">TEST</button>



